import { Subscribable } from './subscribable';
import { Injectable } from '@angular/core';

@Injectable()
export class BaseDomainModel extends Subscribable {}
